import { Box, Stack } from '@mui/material'
import { PropsWithChildren } from 'react'
import { GoBack } from 'src/pages/admin/router/components/GoBack'

export function WrapperTable({ children }: PropsWithChildren) {
    return (
        <Box>
            <Box mb={2}>
                <GoBack />
            </Box>
            {children}
        </Box>
    )
}
